<template>
    <nav id="nav-bar-event">
        <a class="logo" href="#">
            <img src="/themes/ito/images/logo.svg" alt="">
            <h3>Học <strong>Tiêng Anh</strong> qua <strong>Toán và khoa học</strong></h3>
        </a>
        <div class="menu-item select-lang" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#selectLangModal">
            <img class="flag" :src="locate_info.img_flag" alt="" />
        </div>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import { getConfigs, getLanguage } from "../utils/utils";

export default {
    name: "NavBarAuth",

    data() {
        const configs = getConfigs();
        const locate = getLanguage();
        const localizes = configs.localize || [];

        let locate_info = {};
        localizes.forEach(item => {
            if (item.lang == locate) {
                locate_info = item;
            }
        });
        return {
            user: { name: 'Guest' },
            locate: getLanguage(),
            locate_info: locate_info,
            configs: configs,
            localizes: localizes,
        };
    },

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return this.user
        })
    },
    mounted() {
        if (this.locate == 'vi') {
            $.datepicker.setDefaults($.datepicker.regional['vi']);
        } else {
            $.datepicker.setDefaults($.datepicker.regional['']);
        }
    },
    created() {
        this.locate = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'vi';
    },
    methods: {

        setLocate(e) {
            localStorage.setItem('lang', e);
            this.locate = e;
            location.reload();
        },

    }
}
</script>

<style scoped>
#nav-bar-event {
    position: sticky;
    top: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    z-index: 1;
}

#nav-bar-event .logo {
    display: flex;
    width: 250px;
    height: 89px;
    background: #fff;
    margin: 0;
    border-bottom-right-radius: 50px;
}

#nav-bar-event .logo img {
    margin: 15px 0px 15px 15px;
    padding: 10px;
    border-right: 1px solid #E74715;
}

#nav-bar-event .logo h3 {
    font-size: 10px;
    color: #E74715;
    padding-left: 10px;
    margin-top: 35px;
    text-transform: uppercase;
}
#nav-bar-event .menu-item.select-lang{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    height: 70px;
    background: #fff;
    margin: 0;
    border-bottom-left-radius: 50px;
}
.menu-item img.flag{
    width: 35px;
    height: 35px;
}
</style>
